module.exports = __webpack_public_path__ + "img/wagon_parked.ba90b71d.svg";